import ActionTypes from "./actionTypes";
import { getAppStore } from "../../store";
import { LOCAL_STORAGE_KEYS } from "../../../constants/appVars";
import { DealerGroup } from "../../../models/Organization/DealerGroup";

export class DealerGroupStoreActions {
    static loadingDealerGroups(loading: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADING_DEALER_GROUPS, payload: loading });
    }
    static saveDealerGroups(orgs: DealerGroup[]) {
        getAppStore().dispatch({ type: ActionTypes.SAVE_DEALER_GROUPS, payload: orgs });
    }
    static getDealerGroups() {
        return getAppStore().getState().dealerGroup.dealerGroups;
    }
    static getActiveDealerGroup() {
        return getAppStore().getState().dealerGroup.activeDealerGroup;
    }
    static updateDealerGroup(org: DealerGroup) {
        const dGroups = DealerGroupStoreActions.getDealerGroups().map((t) => {
            if (t.id === org.id) {
                return org;
            }
            return t;
        });
        DealerGroupStoreActions.saveDealerGroups(dGroups);
    }
    static addOrUpdateToDealerGroups(org: DealerGroup) {
        let dGroups = DealerGroupStoreActions.getDealerGroups();
        if (dGroups.some((t) => t.data.attrs._id === org.id)) {
            dGroups = dGroups.map((t) => {
                if (t.data.attrs._id === org.id) {
                    return t.updateDealerGroup(org);
                }
                return t;
            });
        } else {
            dGroups = [org, ...dGroups];
        }
        DealerGroupStoreActions.saveDealerGroups(dGroups);
    }
    static setActiveDGroup(org: DealerGroup) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.ACTIVE_DEALER_GROUP, org.id);
        getAppStore().dispatch({ type: ActionTypes.SET_ACTIVE_DEALER_GROUP, payload: org });
    }
    static getSavedDGroupId() {
        return localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_DEALER_GROUP);
    }
}
